import type { WreckContent } from '../content';
import type { EndingId, GameState, RunResult } from './types';

export function salvageValue(baseValue: number, condition: number): number {
  return Math.round((baseValue * Math.max(0, Math.min(100, condition))) / 100);
}

export function calculateRunResult(
  state: GameState,
  content: WreckContent,
  leftDuringEmergency = state.phase === 'emergency',
): RunResult {
  const banked = content.salvage.filter((item) => state.salvage[item.id].banked);
  const bankedSalvageValue = banked.reduce(
    (sum, item) => sum + salvageValue(item.baseValue, state.salvage[item.id].condition),
    0,
  );
  const core = state.salvage[content.requiredSalvageId];
  const coreBanked = core.banked;
  const dataPrismBanked = state.salvage['data-prism'].banked;
  const optionalClasses = new Set(
    banked.flatMap((item) => (item.optionalClass ? [item.optionalClass] : [])),
  );
  const allOptionalClasses = optionalClasses.size === 3;

  let ending: EndingId = 'contract-failed';
  if (coreBanked && leftDuringEmergency) ending = 'barely-escaped';
  else if (coreBanked && core.condition >= 80 && dataPrismBanked) ending = 'precision-salvage';
  else if (coreBanked) ending = 'contract-fulfilled';

  const score = Math.max(
    0,
    bankedSalvageValue +
      Math.max(0, 900 - state.elapsedSeconds) * 2 +
      (coreBanked && core.condition >= 80 ? 400 : 0) +
      (allOptionalClasses ? 250 : 0) -
      state.stats.cableBreaks * 100,
  );

  return {
    ending,
    score: Math.round(score),
    bankedSalvageValue,
    elapsedSeconds: state.elapsedSeconds,
    coreCondition: core.condition,
  };
}
